import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { useToast } from "hooks";
import { LoginContainer, LoginForm } from "components/Login";
import backgroundImage from "assets/images/Faith-2000x1340-c-center.jpg";

/**
 * Login
 *
 * @param {Object} flash
 */
const Login = ({ flash }) => {
  const { toast } = useToast();
  const intl = useIntl();
  const selectedBanner = banners[0];

  useEffect(() => {
    if (!flash) return;

    const type = flash.notice ? "success" : flash.alert ? "error" : null;
    const message = flash.notice || flash.alert;

    if (!type || !message) return;

    const timer = setTimeout(() => {
      toast[type](message);
    }, 500); // wait to ensure <Toaster /> is mounted

    return () => clearTimeout(timer);
  }, [flash]);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Login.Title" })}</title>
      </Helmet>
      <LoginContainer banner={selectedBanner}>
        <LoginForm />
      </LoginContainer>
    </>
  );
};

const banners = [
  {
    title: "Built to support careers, not gigs.",
    label: "Faith Adekogbe",
    description: "Frontend Developer",
    cover: `url(${backgroundImage})`,
  },
];

Login.propTypes = {
  flash: PropTypes.object,
};

export default Login;
